
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator'

// Components
import 'vue3-carousel/dist/carousel.css';
import {
  Carousel,
  Slide,
  Navigation
} from 'vue3-carousel';

// Interfaces
import { IEntity } from '@/interfaces';


@Options({
  components: {
    Carousel,
    Slide,
    Navigation
  }
})
export default class ProfileCard extends Vue {
  settings = {
    itemsToShow: 1,
    snapAlign: 'center'
  }

  breakpoints = {
    700: {
      itemsToShow: 2,
      snapAlign: 'center'
    }
  }

  @Prop(Boolean)
  isEnabledAdd = false;

  @Prop(Array)
  entities: IEntity[] = [];

  handleAdd () {
    this.$emit('submit')
  }

  handleClick (entity: IEntity) {
    this.$emit('on-click', entity)
  }
}
